/**
 * The three-state check-in control, on its own so the Check-in tab and the
 * Start Tournament modal render the same thing.
 *
 * The tick is V1's ✅ and it does NOT change glyph with state — colour does
 * that, exactly as V1 did it. The two other states are words: "Late" and
 * "Not in" have no glyph anyone reads the same way, and inventing one would
 * make the row slower to scan, not faster.
 *
 * Presentation only. The PUT stays with the caller, because both callers
 * already own their own busy and error handling and they surface it in
 * different places — a badge above a table in one, a line in a modal in the
 * other.
 */

/** V1's check-in glyph, U+2705. */
const CHECK_ICON = '✅';

/** Mirrors the CHECK constraint on tournament_entries.check_in_status. */
export const CHECK_IN_STATES = [
  { value: 'checked_in',     label: 'In',     icon: CHECK_ICON },
  { value: 'running_late',   label: 'Late',   icon: null },
  { value: 'not_checked_in', label: 'Not in', icon: null },
];

export default function CheckInToggle({ status, busy = false, disabled = false, onChange }) {
  return (
    <div className="hd-row" style={{ gap: 6 }}>
      {CHECK_IN_STATES.map(({ value, label, icon }) => {
        const active = status === value;
        return (
          <button
            key={value}
            type="button"
            className={`hd-state-btn ${active ? `hd-state-${value}` : ''}`}
            aria-pressed={active}
            disabled={disabled || busy}
            onClick={() => onChange(value)}
          >
            {icon && <span aria-hidden="true">{icon} </span>}
            {label}
          </button>
        );
      })}
    </div>
  );
}
